import { render, staticRenderFns } from "./WhoAmI.vue?vue&type=template&id=d891e324&"
import script from "./WhoAmI.vue?vue&type=script&lang=ts&"
export * from "./WhoAmI.vue?vue&type=script&lang=ts&"
import style0 from "./WhoAmI.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports